import React from 'react';
import Menu from '../../components/MenuElements/Menu';
import SubMenu from '../../components/MenuElements/SubMenu';
import PageHeader from '../Shared/PageHeader';

const Menu01 = () => {
    return (
        <div>
            <PageHeader title="Our Menu" />
            <Menu />
            <SubMenu />
        </div>
    );
};

export default Menu01;